import src from "../../../assets/logo_on_white.svg";
import { Asset } from "../Asset";

export const LogoOnWhite = Asset(src);
